import { useQuery } from '@tanstack/react-query';
import { societyApi } from '../api/societyApi';

/**
 * Hook pour récupérer les utilisateurs d'une société
 */
export const useSocietyUsers = (societyId: string | undefined) => {
  return useQuery({
    queryKey: ['society-users', societyId],
    queryFn: () => societyApi.getSocietyUsers(societyId!),
    enabled: !!societyId,
    staleTime: 30000,
  });
};
